import { PermissionsEnum } from "@/auth/interfaces";
import {
  EstadoPreventaEnum,
  hasPermission,
  ModulosEnumChoice,
  newMotivoPreventaCorporativaSchema,
  ROUTER_PATHS,
  TABLE_CONSTANTS,
  texto,
} from "@/shared";
import { useFetchMotivosRechazo } from "@/shared/actions/erp";
import { CustomAutocomplete, CustomTextArea } from "@/shared/components/ui";
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";
import GeneralTable from "@/shared/components/ui/GeneralTable";
import {
  useCheckPermissionsArray,
  useTableFilter,
  useTableServerSideFiltering,
} from "@/shared/hooks";
import { useTableColumnsPreventa } from "@/shared/hooks/useTableColumnsPreventa";
import {
  FormMotivoRechazoPreventaCorporativa,
  MotivoRechazo,
} from "@/shared/interfaces";
import { yupResolver } from "@hookform/resolvers/yup";
import { Edit, Visibility } from "@mui/icons-material";
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { Grid, IconButton, Tooltip } from "@mui/material";
import { useState } from "react";
import { useForm } from "react-hook-form";
// import { TiposTextFieldNumberEnum } from '@/shared/components/ui/CustomTextFieldNumberComponente';
import {
  fetchGetPreventasCorporativos,
  fetchPutPreventaCorporativo,
} from "@/shared/actions/erp/preventa_corporativo/preventa_corporativo.action";
import InfoCoordendas from "@/shared/components/ui/InfoCoordendas/InfoCoordendas";
import { IPreventaCorporativo } from "@/shared/interfaces/erp/preventa/preventa_corporativo.interface";
import { useNavigate } from "react-router-dom";

interface TablePreventaCorporativoProps {
  showCustomActionBtnSpace?: boolean;
  enableEditing?: boolean;
  estado_preventa?: string;
  viewOnlyMode?: boolean;
  // aprueba_plan_personalizado?: boolean
}

export default function TablePreventaCorporativo({
  showCustomActionBtnSpace = true,
  enableEditing = true,
  estado_preventa = EstadoPreventaEnum.EN_ESPERA,
  viewOnlyMode = false,
}: // aprueba_plan_personalizado
TablePreventaCorporativoProps) {
  useCheckPermissionsArray([
    PermissionsEnum.api_view_preventacoorporativa,
    PermissionsEnum.api_change_preventacoorporativa,
  ]);

  const [modalCancelar, setModalCancelar] = useState(false);

  ///* Form
  const formRechazo = useForm<FormMotivoRechazoPreventaCorporativa>({
    resolver: yupResolver(newMotivoPreventaCorporativaSchema),
  });

  const { reset: resetRechazar } = formRechazo;

  ///* Hook
  const { columnsPreventaCorporativo, columnsPreventaCorporativoWithStatus } =
    useTableColumnsPreventa(estado_preventa as EstadoPreventaEnum);
  const navigate = useNavigate();
  ///* Hook

  const { pagination, setPagination } = useTableFilter();

  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();

  const { pageIndex, pageSize } = pagination;
  ///* Fetch
  const { mutateAsync: updatePreventaCorporativo } =
    fetchPutPreventaCorporativo({});
  const {
    data: motivosRechazoPaging,
    isLoading: isLoadingMotivosRechazo,
    isRefetching: isRefetchingMotivosRechazo,
  } = useFetchMotivosRechazo({
    estado: true,
    modulo: ModulosEnumChoice.PREVENTA_CORPORATIVO,
    page_size: 100,
  });

  const {
    isLoading,
    data: preventasRes,
    isRefetching,
  } = fetchGetPreventasCorporativos({
    page: pageIndex + 1,
    page_size: pageSize,
    ...filterObject,
    filterByState: false,
    estado_preventa_in: estado_preventa,
    // aprueba_plan_personalizado: aprueba_plan_personalizado,
  });

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}></Grid>
        <Grid item xs={12}>
          <GeneralTable<IPreventaCorporativo>
            columns={
              estado_preventa?.includes(EstadoPreventaEnum.PREAPROBADA) 
              || estado_preventa?.includes(EstadoPreventaEnum.EN_ESPERA)?
              columnsPreventaCorporativoWithStatus
              : columnsPreventaCorporativo
            }
            data={preventasRes?.data.data || []}
            //
            isLoading={isLoading}
            isRefetching={isRefetching}
            // // search
            enableGlobalFilter={false}
            // onGlobalFilterChange={setGlobalFilter}
            // pagination
            pagination={pagination}
            onPaging={setPagination}
            rowCount={preventasRes?.data?.count}
            ///* filters - server side
            enableManualFiltering={true}
            columnFilters={columnFilters}
            onColumnFiltersChange={setColumnFilters}
            enableSorting={false}
            // // actions
            // crud
            canDelete={false}
            canEdit={false}
            positionActionsColumn="first"
            actionsColumnSize={TABLE_CONSTANTS.ACTIONCOLUMN_WIDTH_MEDIUM}
            enableEditing={viewOnlyMode ? true : enableEditing}
            showCustomActionBtnSpace={showCustomActionBtnSpace}
            customActionBtnSpace={(selectedRow) => {
              if (viewOnlyMode) {
                return (
                  <Grid container>
                    <Grid item>
                      <Tooltip title={"Ver"} placement="top">
                        <IconButton
                          onClick={() => {
                            navigate(
                              `${ROUTER_PATHS.ventasCorporativas.preventaCorporativoViewNav}/${selectedRow.id_preventa_coorporativa}/${selectedRow.prospecto_corporativo_data.id_prospecto_corporativo}`
                            );
                          }}
                        >
                          <Visibility />
                        </IconButton>
                      </Tooltip>
                    </Grid>
                  </Grid>
                );
              }
              return (
                <Grid container>
                  {
                  // !selectedRow?.aprueba_plan_personalizado &&
                  // selectedRow?.estado_preventa ==
                  //   EstadoPreventaEnum.PREAPROBADA &&
                  // !!!selectedRow?.prospecto_corporativo_data
                  //   ?.condicion_venta ? (
                  //   <Grid item>
                  //     <Tooltip
                  //       title={
                  //         "El registro esta siendo revisado por el supervisor"
                  //       }
                  //       placement="top"
                  //     >
                  //       <IconButton>
                  //         <VisibilityOff />
                  //       </IconButton>
                  //     </Tooltip>
                  //   </Grid>
                  // ) : 
                  hasPermission(
                      PermissionsEnum.api_change_preventacoorporativa
                    ) 
                    // && (selectedRow.preventa_aprobada_factibilidad)
                    // && (!selectedRow.preventa_aprobada_factibilidad ||
                    //   selectedRow.estado_preventa !=
                    //     EstadoPreventaEnum.PREAPROBADA) 
                    ? (
                    <>
                      <Grid item>
                        <Tooltip title={"Editar"} placement="top">
                          <IconButton
                            onClick={() => {
                              if (
                                selectedRow.estado_preventa ==
                                EstadoPreventaEnum.PREAPROBADA
                              ) {
                                navigate(
                                  `${ROUTER_PATHS.ventasCorporativas.preventaCorporativoCompletarNav}/${selectedRow.id_preventa_coorporativa}/${selectedRow.prospecto_corporativo_data.id_prospecto_corporativo}`
                                );
                              } else {
                                navigate(
                                  `${ROUTER_PATHS.ventasCorporativas.preventaCorporativoEditNav}/${selectedRow.id_preventa_coorporativa}/${selectedRow.prospecto_corporativo_data.id_prospecto_corporativo}`
                                );
                              }
                            }}
                          >
                            <Edit />
                          </IconButton>
                        </Tooltip>
                      </Grid>
                      <Grid item>
                        <Tooltip title={texto.cancelado} placement="top">
                          <IconButton
                            onClick={() => {
                              setModalCancelar(true);
                              formRechazo.reset({
                                ...formRechazo.getValues(),
                                id_preventa_corporativa:
                                  selectedRow.id_preventa_coorporativa,
                                razon_social:
                                  selectedRow?.prospecto_corporativo_data
                                    .razon_social,
                                identificacion:
                                  selectedRow?.prospecto_corporativo_data
                                    .identificacion,
                              });
                            }}
                          >
                            <HighlightOffIcon color="error" />
                          </IconButton>
                        </Tooltip>
                      </Grid>
                    </>
                  ) : null}
                </Grid>
              );
            }}
          />
        </Grid>
      </Grid>

      {/*Modal para cancelar*/}

      {modalCancelar && (
        <ScrollableDialogProps
          open={modalCancelar}
          title="¡Confirmar!"
          confirmVariantBtn="contained"
          dialogContentText={`Estás a punto de cancelar una preventa del cliente ${
            formRechazo.getValues().razon_social
          }
          con la identificación ${
            formRechazo.getValues().identificacion
          }. ¿Estás seguro? Este cambio es irreversible.`}
          contentNode={
            <Grid container spacing={3}>
              <CustomAutocomplete<MotivoRechazo>
                label="Motivo de rechazo"
                name="motivo_rechazo"
                // options
                options={motivosRechazoPaging?.data?.data || []}
                valueKey="nombre"
                actualValueKey="codigo"
                defaultValue={formRechazo.getValues().motivo_rechazo || ""}
                isLoadingData={
                  isLoadingMotivosRechazo || isRefetchingMotivosRechazo
                }
                // validation
                control={formRechazo.control}
                error={formRechazo?.formState?.errors.motivo_rechazo}
                helperText={
                  !!formRechazo?.formState?.errors.motivo_rechazo?.message &&
                  "El motivo de rechazo es requerido"
                }
                disableClearable
              />

              <CustomTextArea
                label="Observación"
                name="observacion_cancelacion"
                maxRows={3}
                control={formRechazo.control}
                defaultValue={
                  formRechazo.getValues().observacion_cancelacion ?? ""
                }
                error={formRechazo.formState.errors.observacion_cancelacion}
                helperText={
                  formRechazo.formState.errors.observacion_cancelacion?.message
                }
                required={false}
              />
            </Grid>
          }
          onConfirm={formRechazo.handleSubmit(async (form) => {
            const resp = await updatePreventaCorporativo({
              id_preventa_coorporativa: form.id_preventa_corporativa,
              estado_preventa: EstadoPreventaEnum.CANCELADO,
              motivo_rechazo: form.motivo_rechazo,
              observaciones: {
                ...form.observaciones,
                observacion_cancelar: form.observacion_cancelacion,
              },
              observacion_rechazo: [
                {
                  motivo: formRechazo.getValues().motivo_rechazo,
                  observacion: formRechazo.getValues().observacion_cancelacion,
                  fecha: new Date().toISOString(),
                },
              ],
            });
            if (resp.code === 200) {
              resetRechazar({});
              setModalCancelar(false);
              //window.location.reload()
            }
          })}
          onClose={() => {
            resetRechazar({});
            setModalCancelar(false);
          }}
        />
      )}

      <InfoCoordendas />
    </>
  );
}
